<template>
  <form class="form form_w403 form_pt100 form_pt_m60 pb52" @submit.prevent="doAction">
    <div class="form__head mb24">
      <h2 class="form__title">{{ $t("auth.signup") }}</h2>
    </div>

    <div class="form__content">
      <div class="form-item form-item_flex form-item_between mb24 flex-m-column">
        <div class="form-item_half form-item_half_w46 mb24_m">
          <el-input
            :placeholder="$t('forms.firstName')"
            type="text"
            v-model="form.first_name"
            autocomplete="off"
          ></el-input>
        </div>

        <div class="form-item_half form-item_half_w46">
          <el-input
            :placeholder="$t('forms.lastName')"
            type="text"
            v-model="form.last_name"
            autocomplete="off"
          ></el-input>
        </div>
      </div>

      <div class="form-item form-item_flex mb24 form-item_between flex-m-column">
        <el-input
          :placeholder="$t('forms.email')"
          type="email"
          v-model="form.email"
          autocomplete="off"
        ></el-input>
      </div>

      <div class="form-item mb24">
        <p class="form-item__text form-item__text_foz12">
          {{ $t("forms.confirmRules") }}
          <a href="#" class="form-item__link">
            {{
            $t("forms.confirmRulesLink")
            }}
          </a>
        </p>
      </div>

      <div class="form-item mb24">
        <div>
          <input
            class="form-item__checkbox"
            type="checkbox"
            id="rules-confirm"
            v-model="form.agree"
          />
          <label class="form-item__checkbox-label" for="rules-confirm">
            <span class="form-item__text_foz12 form-item__text_usn">
              {{
              $t("forms.agreeSub")
              }}
            </span>
          </label>
        </div>
      </div>

      <div class="form-item mb24">
        <div>
          <input
            class="form-item__checkbox"
            type="checkbox"
            id="rules-confirm2"
            v-model="form.marketing"
          />
          <label class="form-item__checkbox-label" for="rules-confirm2">
            <span class="form-item__text_foz12 form-item__text_usn">
              {{
              $t("forms.yesGetEmails")
              }}
            </span>
          </label>
        </div>
      </div>

      <div class="form-item mb24">
        <button
          class="btn btn_upper"
          :disabled="!isValid"
          :class="{
            btn_disabled: !isValid,
          }"
        >{{ $t("buttons.register") }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import checkEmail from "@/helpers/utils/emailCheck";

export default {
  name: "signup",
  computed: {
    isValid() {
      return !this.$v.$invalid;
    }
  },
  data() {
    return {
      form: {}
    };
  },
  validations: {
    form: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      email: {
        required,
        checkEmail
      },
      agree: {
        required,
        same: sameAs(() => true)
      },
      marketing: {
        required,
        same: sameAs(() => true)
      }
    }
  },
  methods: {
    ...mapActions({
      register: "auth/register"
    }),
    async doAction() {
      const response = await this.register(this.prepareForm());
      this.handleResponse(response);
      this.$log("authorization_registration");
    },
    handleResponse(response) {
      if (response.status == 422) {
        if (response.data.fields == undefined) {
          return;
        }

        if (response.data.fields[0] == undefined) {
          return;
        }

        this.$notify({
          title: this.$t("notifications.validationError"),
          message: response.data.fields[0].message,
          duration: 5000
        });
      }
    },
    prepareForm() {
      return {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        email: this.form.email,
        phone: localStorage.getItem("userPhone"),
        is_company: false,
        type_app: "web_client",
        office_id: localStorage.getItem("office_id")
      };
    }
  }
};
</script>
